/* RK mobile menu drawer (Graff phone menu): full-screen panel opened by the header
   hamburger ([data-rk-mm-open]); L2/L3 panels slide in over the root (0.3s), back
   buttons pop them, X / Esc close everything. Body scroll is locked while open. */
(function () {
  function init() {
    var mm = document.querySelector('[data-rk-mm]');
    if (!mm) return;
    var openBtns = document.querySelectorAll('[data-rk-mm-open]');
    var stack = [];

    /* The drawer's banner images ship as data-rk-mm-* and only become real requests
       the first time the drawer is opened. Order matters: sizes, then srcset, then src,
       so the browser picks a candidate with the correct sizes already in place. */
    var hydrated = false;
    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      mm.querySelectorAll('[data-rk-mm-src]').forEach(function (img) {
        var sizes = img.getAttribute('data-rk-mm-sizes');
        var srcset = img.getAttribute('data-rk-mm-srcset');
        if (sizes) img.setAttribute('sizes', sizes);
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', img.getAttribute('data-rk-mm-src'));
      });
    }

    function setOpen(open) {
      if (open) hydrate();
      mm.classList.toggle('is-open', open);
      mm.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (!open) {
        stack.forEach(function (p) { p.classList.remove('is-active'); });
        stack = [];
      }
    }

    openBtns.forEach(function (b) {
      b.addEventListener('click', function () { setOpen(true); });
    });
    mm.querySelectorAll('[data-rk-mm-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mm.classList.contains('is-open')) setOpen(false);
    });

    mm.querySelectorAll('[data-rk-mm-push]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = mm.querySelector('[data-rk-mm-panel="' + btn.getAttribute('data-rk-mm-push') + '"]');
        if (!p) return;
        p.scrollTop = 0;
        p.classList.add('is-active');
        stack.push(p);
      });
    });
    mm.querySelectorAll('[data-rk-mm-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = stack.pop();
        if (p) p.classList.remove('is-active');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && (e.target.querySelector('[data-rk-mega]') || e.target.querySelector('[data-rk-mm]'))) init(); });
})();
